var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardTable',{attrs:{"header":"Past Leaks","tableHeaders":_vm.headers,"tableData":_vm.pastAlerts.leakList}})
}
var staticRenderFns = []

export { render, staticRenderFns }